<div class="left-aligned">
  <ng-content></ng-content>
</div>
<ng-content select="gax-page-footer-actions"></ng-content>
